import React from 'react';
import PropTypes from 'prop-types';
import { 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow 
} from '@mui/material';
import { handleDate } from '../../../../utils/helper';

const Rent50Socket = ({statement}) => {

  const {
    sockets50,
    rentDaily50,
    rentActual50,
    rentPerSocket50,
    applicableStartDate,
  } = statement.data;

  const rentEndDate = statement.endDate

  return (
    <div className="mb-6">
      <h3 className="text-[18px] font-semibold mb-2">50 KwH sockets</h3>
      <h3 className="text-[16px] font-semibold mb-2">{`Basic rent payable: £${rentPerSocket50}`}</h3>
      <TableContainer>
        <Table 
          aria-label="ac-sockets" 
          sx={{
            borderCollapse: 'separate',
            borderRadius: '15px',
            border: '1px solid rgb(224, 224, 224)',
          }}>
          <TableHead>
            <TableRow>
              <TableCell sx={{fontWeight: 'bold'}}>Rent start date</TableCell>
              <TableCell sx={{fontWeight: 'bold'}}>Rent end date</TableCell>
              <TableCell sx={{fontWeight: 'bold'}}>No. installed points</TableCell>
              <TableCell sx={{fontWeight: 'bold'}}>Daily rent due</TableCell>
              <TableCell sx={{fontWeight: 'bold'}} align='right'>Total rent due</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            <TableRow>
              <TableCell>{handleDate(applicableStartDate)}</TableCell>
              <TableCell>{handleDate(rentEndDate)}</TableCell>
              <TableCell>{sockets50}</TableCell>
              <TableCell>{`£${rentDaily50.toFixed(2)}`}</TableCell>
              <TableCell align='right'>{`£${rentActual50.toFixed(2)}`}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

export default Rent50Socket;

Rent50Socket.propTypes = {
  statement: PropTypes.object.isRequired,
};